import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  corporateList: [],
};

export const corporateSlice = createSlice({
  name: "corporateList",
  initialState,
  reducers: {
    updateCorporateSlice(state, action) {
      state.corporateList = action.payload.corporateList;
    },
  },
});

export const corporateListActions = corporateSlice.actions;

export default corporateSlice.reducer;
